import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
} from '@stripe/react-stripe-js';
import store from 'config/store';
import './config/i18n'
import App from 'App/App';
import './index.css';

const stripePromise = loadStripe('pk_test_51IObkWLfMIAxiu8lpKMB0SFfXOF4onPUXMPCNIn1Wh8Tw6a1FkW5mDCRrLrWbIBDpirgvyZ3BaOAiNgRWu3O3QqR00Cwn14dNi');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename='/portal'>
    <Provider store={store}>
      <React.StrictMode>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </React.StrictMode>
    </Provider>
  </BrowserRouter>
);
